import { SidebarProvider } from '@/components/ui/sidebar';

import AppSidebar from '@/layouts/AppSidebar';
import { MainContent } from './components/MainContent';

/**
 * 基础布局组件
 * 提供侧边栏导航、面包屑导航和主题切换功能
 */
export default function BasicLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <MainContent />
    </SidebarProvider>
  );
}
